// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vue-card-stack__wrapper[data-v-18dab2a5]{position:relative}.vue-card-stack__stack[data-v-18dab2a5]{overflow:hidden;position:relative}.vue-card-stack__card[data-v-18dab2a5]{-webkit-backface-visibility:hidden;backface-visibility:hidden;cursor:-webkit-grab;cursor:grab;-webkit-perspective:1000px;perspective:1000px;position:absolute;-webkit-transform-origin:0 50%;transform-origin:0 50%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
